<template>
      <div class="index container">

        <transition name="fade">
          <router-view @showParent="showParent">
          </router-view>
        </transition>
        
        <div v-if="showParentPage">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item
              :exact="true"
              :to="{ name: 'contactType', params: {} }"
              active
            >
              Contact Type
            </v-breadcrumbs-item>
          </v-breadcrumbs>

        <div class="d-flex flex-column flex-lg-row">
          <v-text-field
            dense
            v-model="searchTerms"
            @keyup.enter="search"
            @click:clear="clearSearch"
            @click:append="search"
            placeholder="Press enter to begin search"
            append-icon="mdi-magnify"
            outlined
            clearable
            label="Search"
          />
          <v-btn
            class="ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start"
            color="primary"
            :to="{ name: 'contactTypeCreate', params: {} }"
          >
            Create Contact Type
          </v-btn>
        </div>

        <div class="table-container">
          <v-data-table
            :headers="headers"
            :items="contactTypeList"
            :items-per-page="pagination.pageSize"
            :loading="!contactTypeProcessed"
            :server-items-length="pagination.totalSize"
            :page="pagination.current"
            :disable-pagination="!contactTypeList || contactTypeList.length < 1"
            :hide-default-header="!contactTypeList || contactTypeList.length < 1"
            :hide-default-footer="!contactTypeList || contactTypeList.length < 1"
            :disable-sort="true"
            item-key="id"
            class="elevation-1"
            @update:options="pageChanged"
          >
            
            <template v-slot:item.description="{ item }">
              <a @click="view(item)">{{ item.description }}</a>
            </template>
            
          <template v-slot:item.has_student="{ item }">
            <a @click="view(item)">{{ item.has_student ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_teacher="{ item }">
            <a @click="view(item)">{{ item.has_teacher ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_ledger="{ item }">
            <a @click="view(item)">{{ item.has_ledger ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_appointment="{ item }">
            <a @click="view(item)">{{ item.has_appointment ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_note="{ item }">
            <a @click="view(item)">{{ item.has_note ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_calls="{ item }">
            <a @click="view(item)">{{ item.has_calls ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_email="{ item }">
            <a @click="view(item)">{{ item.has_email ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_sms="{ item }">
            <a @click="view(item)">{{ item.has_sms ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_inquiry="{ item }">
            <a @click="view(item)">{{ item.has_inquiry ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_group="{ item }">
            <a @click="view(item)">{{ item.has_group ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_attachment="{ item }">
            <a @click="view(item)">{{ item.has_attachment ? 'Yes':'No'}}</a>
          </template>
          
          <template v-slot:item.has_car="{ item }">
            <a @click="view(item)">{{ item.has_car ? 'Yes':'No'}}</a>
          </template>
          
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="edit(item)">
                mdi-pencil
              </v-icon>
              <v-icon small class="mr-2" @click="remove(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </div>
      <confirmation-dialog ref="confirm" />
    </div>
  </template>

    <script>
    import { mapActions, mapGetters } from "vuex";
    const ConfirmationDialog = () =>
    import("@/components/common/ConfirmationDialog.vue");
  
    export default {
      data(){
        return {
          pagination: {
            current: 1,
            pageSize: 10,
            totalSize: 100
          },
          contactTypeList: [],
          showParentPage: true,
          
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
          sortable: true
        },
        {
          text: "Description",
          value: "description",
          align: "start",
          sortable: false
        },
        {
          text: "Has Student",
          value: "has_student",
          align: "start",
          sortable: false
        },
        {
          text: "Has Teacher",
          value: "has_teacher",
          align: "start",
          sortable: false
        },
        {
          text: "Has Ledger",
          value: "has_ledger",
          align: "start",
          sortable: false
        },
        {
          text: "Has Appointment",
          value: "has_appointment",
          align: "start",
          sortable: false
        },
        {
          text: "Has Notes",
          value: "has_note",
          align: "start",
          sortable: false
        },
        {
          text: "Has Calls",
          value: "has_calls",
          align: "start",
          sortable: false
        },
        {
          text: "Has Emails",
          value: "has_email",
          align: "start",
          sortable: false
        },
        {
          text: "Has SMS",
          value: "has_sms",
          align: "start",
          sortable: false
        },
        {
          text: "Has Inquiry",
          value: "has_inquiry",
          align: "start",
          sortable: false
        },
        {
          text: "Has Group",
          value: "has_group",
          align: "start",
          sortable: false
        },
        {
          text: "Has Attachment",
          value: "has_attachment",
          align: "start",
          sortable: false
        },
        {
          text: "Has Car",
          value: "has_car",
          align: "start",
          sortable: false
        },
        
        { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
          sort: {
            key: null
          },
          searchTerms : ''
        }
      },
      components: {
        ConfirmationDialog
      },
      computed: {
        ...mapGetters("contactType", ["contactTypeProcessed", "getContactTypes"]),
      },
      methods: {
        ...mapActions("messages", [
          "addErrorMessage",
          "addMessage",
          "addSuccessMessage"
        ]),
        ...mapActions("contactType", ["deleteContactType", "fetchContactTypes"]),
        view(item){
          this.$router.push({ name: 'contactTypeView', params: { id: item.id }})
        },
        edit(item){
          this.$router.push({ name: "contactTypeEdit", params: { id: item.id }})
        },
        async remove(item){
          let confirm = await this.$refs.confirm.open(
            "Confirm Delete",
            "Do you want to delete this contactType?"
          );
          if(confirm){
            this.deleteContactType(item.id)
              .then( () => {
                this.addSuccessMessage("contactType was deleted successfully");
                this.getResources();
              }).catch( () => {
                this.addErrorMessage("Server response with error ");
              });
          }
        },
        getResources() {
          const params = {
            page: this.pagination.pageIndex && this.pagination.pageIndex > 0 ? this.pagination.pageIndex-1:0,
            size: this.pagination.pageSize,
          };
          this.fetchContactTypes(params)
            .then(response => {
              if(response){
                this.pagination.totalSize = response.totalElements;
                this.contactTypeList = response.content;
              }
            })
            .catch(error => {
              this.addErrorMessage("Server response with error " + error);
            });
        },
        showParent(show) {
          this.showParentPage = show;
        },
        pageChanged(pagination) {
          this.pagination.pageIndex = pagination.page;
          this.pagination.pageSize = pagination.itemsPerPage;

          this.getResources()
        },
        search(){
          this.getResources();
        },
        clearSearch(){
          this.searchTerms = null;
          this.getResources();
        }
      },
      watch: {
        'pagination.numberRegisterForPage': function(){
            this.pagination.current = -1;
        },
      },
      beforeRouteUpdate(to, from, next) {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        this.showParentPage = toDepth < fromDepth;
        if (this.showParentPage) {
          this.getResources();
        }
        next();
      }
    }
    </script>

    